import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateNewFixedFees,
  getNewFixedFeesList,
  updateList,
  id,
  history,
  getSingleNewFixedFees,
  updating,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    code: '',
    description: '',
    multiplier: '',
    amount: '',
    for_new: 0,
    for_renewal: 0,
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    description: 'required',
    multiplier: 'text_underscore',
    amount: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      code: _.get(formData, 'code').toUpperCase(),
      multiplier: (_.get(formData, 'multiplier') || '').toLowerCase(),
      for_new: _.get(formData, 'for_new') ? _.get(formData, 'for_new') : 0,
      for_renewal: _.get(formData, 'for_renewal')
        ? _.get(formData, 'for_renewal')
        : 0,
      ordinance_revision_id: ordinanceRevisionId,
    };

    updateNewFixedFees(id, args, ({ data }) => {
      setModal({ isOpen: false });
      getNewFixedFeesList({ ordinance_revision_id: ordinanceRevisionId });
      getSingleNewFixedFees(id);
      history.push(`/bpls/tax-revenue/new-fixed-fees/${_.get(data, 'id')}`);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, {});

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onCheck = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              placeholder="Ex. CODE-1234"
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'code')}
              disabled
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description: {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
              disabled
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Multiplier: {validateForm.renderMessage('multiplier')}
            </label>
            <input
              className="form-control"
              type="text"
              name="multiplier"
              onChange={onChange}
              placeholder="Ex. code_multiplier"
              style={{ textTransform: 'lowercase' }}
              value={_.get(formData, 'multiplier')}
              disabled
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <input
              className="form-control"
              type="number"
              name="amount"
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'amount')}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              For New: &nbsp;
            </label>
            <input
              name="for_new"
              type="checkbox"
              checked={_.get(formData, 'for_new')}
              onChange={onCheck}
              required={formData.for_renewal === 0}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              For Renewal: &nbsp;
            </label>
            <input
              name="for_renewal"
              type="checkbox"
              checked={_.get(formData, 'for_renewal')}
              onChange={onCheck}
              required={formData.for_new === 0}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateNewFixedFees: PropTypes.instanceOf(Function).isRequired,
  getNewFixedFeesList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewFixedFees: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_NEW_FIXED_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
